import { ReactComponent as Minus } from "../../../assets/icons/minus.svg";
import { ReactComponent as Plus } from "../../../assets/icons/plus.svg";

const CollapseComponent = ({
  toggle,
  open,
  text,
  snapshot,
  onClear,
  expandedView = false,
}: {
  toggle: () => void;
  open: boolean;
  text: string;
  snapshot: boolean;
  onClear?: () => void;
  expandedView?: boolean;
}) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-2 ml-4">
        <div className="cursor-pointer" onClick={toggle}>
          {open ? <Minus /> : <Plus />}
        </div>
        <div className="text-md font-semibold text-secondary opacity-100 font-poppins">
          {text}
        </div>
      </div>
      {!(snapshot || expandedView) && (
        <button onClick={onClear} className="text-red-700 mr-4 text-xs">
          Clear
        </button>
      )}
    </div>
  );
};

export default CollapseComponent;
